import { useState } from "react";
import { motion } from "framer-motion";
import { XCircle, CheckCircle2, ChevronDown } from "lucide-react";

export default function Myths({ myths = [] }) {
  const [openId, setOpenId] = useState(myths[0]?.id ?? null);

  return (
    <section id="mythen" className="scroll-mt-24 py-20 lg:py-28 bg-[#F3EFE6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <span className="text-xs uppercase tracking-widest font-semibold text-[#C87D55]">Aufklärung</span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#1C2D24]">
            Mythen vs. Fakten
          </h2>
          <p className="mt-4 text-lg text-[#4A5D52] leading-relaxed">
            Rund um Ernährung und Osteoporose kursieren viele Halbwahrheiten. Wir stellen den weit verbreiteten
            Irrtümern die aktuelle wissenschaftliche Evidenz gegenüber.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {myths.map((m, i) => {
            const isOpen = openId === m.id;
            return (
              <motion.div
                key={m.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 2) * 0.1 }}
                className="bg-white rounded-2xl ring-1 ring-[#E2DDD3] overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
              >
                <button
                  data-testid={`myth-card-toggle-${m.id}`}
                  onClick={() => setOpenId(isOpen ? null : m.id)}
                  className="w-full text-left p-6 flex items-start gap-3"
                >
                  <XCircle className="w-6 h-6 text-[#C87D55] shrink-0 mt-0.5" />
                  <span className="flex-1">
                    <span className="block text-xs uppercase tracking-widest text-[#C87D55] font-semibold mb-1">Mythos</span>
                    <span className="font-semibold text-[#1C2D24] leading-snug">{m.myth}</span>
                  </span>
                  <ChevronDown className={`w-5 h-5 text-[#769777] shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`} />
                </button>
                {isOpen && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    className="px-6 pb-6"
                  >
                    <div className="flex items-start gap-3 bg-[#E2EBE1] rounded-xl p-4">
                      <CheckCircle2 className="w-6 h-6 text-[#2D5A27] shrink-0 mt-0.5" />
                      <span>
                        <span className="block text-xs uppercase tracking-widest text-[#2D5A27] font-semibold mb-1">Fakt</span>
                        <span className="text-[#1C2D24] leading-relaxed">{m.fact}</span>
                      </span>
                    </div>
                  </motion.div>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
